import { Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { CheckCircle } from '@phosphor-icons/react';
import { date, string } from '@eti/utils';
import { css } from '@eti/styles';
import { useDateFormat } from '@eti/providers';
import { screenReaderOnly } from '../../common/utils/styles';
import { findTransferBound } from './utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const boundStyle = css`
  justify-content: space-between;
  padding-inline: 8px;
`;
const TransferDirection = props => {
  const {
    transferBounds,
    direction
  } = props;
  const bound = findTransferBound(transferBounds, direction);
  return /*#__PURE__*/_jsxs(Inline, {
    spacing: 4,
    children: [/*#__PURE__*/_jsx(Text, {
      children: bound === null || bound === void 0 ? void 0 : bound.departureStation
    }), /*#__PURE__*/_jsx(Text, {
      children: "-"
    }), /*#__PURE__*/_jsx(Text, {
      children: bound === null || bound === void 0 ? void 0 : bound.arrivalStation
    })]
  });
};
const TransferBoundAvailability = ({
  title,
  available,
  boundsData,
  direction,
  departsText,
  fromText,
  showDepartureTime,
  toText
}) => {
  const {
    shortWeekdayYear,
    time,
    weekdayYear
  } = useDateFormat();
  const directionBound = findTransferBound(boundsData, direction);
  const formatArrivalDate = weekdayFormat => {
    var _directionBound$arriv;
    return string.firstToUpperCase(date.format((_directionBound$arriv = directionBound === null || directionBound === void 0 ? void 0 : directionBound.arrivalDateTime) !== null && _directionBound$arriv !== void 0 ? _directionBound$arriv : '', weekdayFormat));
  };
  const localeDate = formatArrivalDate(shortWeekdayYear);
  const departureTime = showDepartureTime && directionBound !== null && directionBound !== void 0 && directionBound.departureDateTime ? `${departsText} ${date.format(directionBound.departureDateTime, time)}` : null;
  const screenReaderLabel = [`${fromText} ${directionBound === null || directionBound === void 0 ? void 0 : directionBound.departureStation} ${toText} ${directionBound === null || directionBound === void 0 ? void 0 : directionBound.arrivalStation}`, formatArrivalDate(weekdayYear), departureTime, available].filter(Boolean).join(', ');
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 8,
    children: [/*#__PURE__*/_jsx(Text, {
      variant: textVariants._14_BOLD,
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      className: screenReaderOnly,
      "data-testid": "bound-screen-reader-label",
      children: screenReaderLabel
    }), /*#__PURE__*/_jsxs(Inline, {
      "aria-hidden": "true",
      className: boundStyle,
      spacing: 4,
      children: [/*#__PURE__*/_jsxs(Stack, {
        spacing: 0,
        children: [/*#__PURE__*/_jsx(TransferDirection, {
          direction: direction,
          transferBounds: boundsData
        }), /*#__PURE__*/_jsx(Text, {
          children: localeDate
        }), departureTime && /*#__PURE__*/_jsx(Text, {
          "data-testid": "bound-departure-time",
          children: departureTime
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        spacing: 4,
        children: [/*#__PURE__*/_jsx(CheckCircle, {
          "aria-hidden": true,
          color: vars.colors.signal.positive.foreground,
          "data-testid": "add-icon",
          size: 20,
          weight: "regular"
        }), /*#__PURE__*/_jsx(Text, {
          children: available
        })]
      })]
    })]
  });
};
export default TransferBoundAvailability;
//# sourceMappingURL=TransferBoundAvailability.js.map